import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const labelVariants = cva(
  'flex w-fit max-w-full items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        option: 'text-sm font-normal',
        caption: 'text-xs text-muted-foreground',
        meta: 'text-xs font-normal text-muted-foreground',
        report: 'min-h-control-md gap-3 px-2 text-xs font-normal',
      },

      appearance: {
        default: '',
        filter: 'text-muted-foreground px-2',
        count: 'text-foreground/70 group-hover:text-accent-foreground gap-1 truncate',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

function Label({
  appearance = 'default',
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<'label'> & VariantProps<typeof labelVariants>) {
  return (
    <label
      data-slot="label"
      className={cn(labelVariants({ variant, appearance }), className)}
      {...props}
    />
  );
}

export { Label,  };
